// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1j_DS","buttons":"SendReceipts_buttons__3zZWB","email":"SendReceipts_email__3Y5il","bookApptTitle":"SendReceipts_bookApptTitle__31BaD"};